export default "__VITE_ASSET__gWFHCMAy__"